var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "partner-page" },
    [
      _vm._m(0),
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "关键词" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearch($event)
                      },
                    },
                    model: {
                      value: _vm.searchForm.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchForm,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchForm.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.cooperationStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "cooperationStatus", $$v)
                        },
                        expression: "searchForm.cooperationStatus",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "待启用", value: "pending" },
                      }),
                      _c("el-option", {
                        attrs: { label: "已合作", value: "active" },
                      }),
                      _c("el-option", {
                        attrs: { label: "已暂停", value: "suspended" },
                      }),
                      _c("el-option", {
                        attrs: { label: "已终止", value: "terminated" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.openBind } }, [
                    _vm._v("绑定供应商"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticClass: "table-card",
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.tableData.data, size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "supplierNo",
                  label: "编号",
                  "min-width": "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierName",
                  label: "名称",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(_vm.statusText(row.relation.cooperationStatus))
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "relation.paymentTerms",
                  label: "账期",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "relation.creditLimit",
                  label: "授信",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "purchaseCount", label: "采购单", width: "80" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "260" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openEdit(row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._l(row.actions, function (action) {
                          return _c(
                            "el-button",
                            {
                              key: action,
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.runAction(row, action)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.actionText(action)))]
                          )
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-size": _vm.searchForm.limit,
                  "current-page": _vm.searchForm.page,
                  layout: "total, prev, pager, next",
                  total: _vm.tableData.total,
                },
                on: {
                  "current-change": function (page) {
                    _vm.searchForm.page = page
                    _vm.loadList()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.form.id ? "编辑合作条款" : "绑定平台供应商",
            visible: _vm.visible,
            width: "620px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "110px", size: "small" } },
            [
              !_vm.form.id
                ? _c(
                    "el-form-item",
                    { attrs: { label: "平台供应商" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { filterable: "", placeholder: "选择供应商" },
                          model: {
                            value: _vm.form.supplierId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "supplierId", $$v)
                            },
                            expression: "form.supplierId",
                          },
                        },
                        _vm._l(_vm.platformOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.name + " (" + item.supplierNo + ")",
                              value: item.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "账期" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.paymentTerms,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "paymentTerms", $$v)
                      },
                      expression: "form.paymentTerms",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "价格政策" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 2 },
                    model: {
                      value: _vm.form.pricePolicy,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "pricePolicy", $$v)
                      },
                      expression: "form.pricePolicy",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "授信额度" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.creditLimit,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "creditLimit", $$v)
                      },
                      expression: "form.creditLimit",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系人" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.contactName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "contactName", $$v)
                      },
                      expression: "form.contactName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系电话" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.contactPhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "contactPhone", $$v)
                      },
                      expression: "form.contactPhone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 2 },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.submit },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hero" }, [
      _c("div", [
        _c("span", [_vm._v("SUPPLIER COOP")]),
        _c("h2", [_vm._v("供应商合作")]),
        _c("p", [_vm._v("从平台供应商库挑选、设置账期授信并启用合作。")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }